import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import api from '../lib/api';

const LAST_SEEN_KEY = 'tricorps360.lastSeenVersion';
// Module-level so the "you're on a new version" toast fires once per page load
// even though both Layout and Sidebar read the version.
let announced = false;

/**
 * App version + build stamp from /api/version (single source of truth is
 * /app/VERSION). Also announces a version change once, the first time a user
 * loads a release they haven't seen.
 */
export function useAppVersion({ announce = false } = {}) {
  const [info, setInfo] = useState({ version: '', released: '', build: '' });

  useEffect(() => {
    let cancelled = false;
    api.get('/version')
      .then((res) => {
        if (cancelled) return;
        setInfo(res.data);
        if (!announce || announced || !res.data?.version) return;
        announced = true;
        let seen = null;
        try { seen = localStorage.getItem(LAST_SEEN_KEY); } catch {/* private mode */}
        try { localStorage.setItem(LAST_SEEN_KEY, res.data.version); } catch {/* ignore */}
        // Stay quiet for a first-ever visit — only announce an actual change.
        if (seen && seen !== res.data.version) {
          toast.success(`Updated to v${res.data.version}`, {
            description: "You're on the latest version of TriCorps360.",
            duration: 8000,
            action: { label: "See what's new", onClick: () => { window.location.href = '/whats-new'; } },
          });
        }
      })
      .catch(() => {/* offline or cold boot — the footer just shows a dash */});
    return () => { cancelled = true; };
  }, [announce]);

  return info;
}
